import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ContactsShell from "../contacts/ContactsShell";
import { api } from "../../../lib/apiClient";

export default function WorkspaceContactsPage() {
  const { workspaceId } = useParams();
  const [ws, setWs] = useState(null);
  useEffect(() => {
    api.get(`/api/admin/workspaces/${workspaceId}/summary`).then(setWs).catch(() => setWs(null));
  }, [workspaceId]);
  return (
    <ContactsShell
      scope="workspace"
      workspaceId={workspaceId}
      scopeLabel={ws ? `${ws.name} · ${ws.contact_count} contacts · ${ws.member_count} members` : `Workspace ${workspaceId}`}
      scopeHref={`/admin/workspaces/${workspaceId}`}
    />
  );
}
